import { render, staticRenderFns } from "./GoogleLoginButton.vue?vue&type=template&id=6e34f45d"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=js"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=js"
import style0 from "./GoogleLoginButton.vue?vue&type=style&index=0&id=6e34f45d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports